module.exports = __webpack_public_path__ + "img/madington-teal.801ba5b.svg";